
import React from "react";
import { CustomToolTip } from "../Caseload/CustomTooltip";
import { ReactComponent as DigitalIcon } from "../Common/Icons/digital.svg";
import { ReactComponent as GreenIcon } from "../Common/Icons/green.svg";
import { ReactComponent as AutomatableIcon } from "../Common/Icons/automatable.svg";

const styles = {padding:"2px"}

export const SkillTypeBlock = ({skill_types=[], greyScale}) => {
  return (
    <>
      {skill_types.includes("digital skill") && <CustomToolTip title={"Digital Skill"}><DigitalIcon styles={styles} stroke={greyScale ? "grey" : "#4285F4"}/></CustomToolTip>}
      {skill_types.includes("green skill") && <CustomToolTip title={"Green Skill"}><GreenIcon styles={styles} stroke={greyScale ? "grey" : "#2ECC71"}/></CustomToolTip>}
      {skill_types.includes("automatable skill") && <CustomToolTip title={"Automatable Skill"}><AutomatableIcon styles={styles} stroke={greyScale ? "grey" : "#AB47BC"}/></CustomToolTip>}
    </>
  )
}
